// Number and money wording for challenge terms. The words are the platform's
// one number and money text (`platform_types::money_text`, through the
// installed rule-text module, `./ruleText`); this file only names the looks
// the challenge pages use. Money is written in the currency its owner
// recorded, which every look takes.

import { cleanNumberText, moneyText } from './ruleText';

/** A limit as challenge-text states it: a percent, or money in the currency
 *  of the terms it belongs to (which the caller names). */
export type Amount = { unit: 'percent'; value: string } | { unit: 'money'; value: string };

/** The account sizes firms actually sell. */
export const ACCOUNT_SIZES = ['5000', '10000', '25000', '50000', '100000', '200000'] as const;

/** "10.0000" → "10", "5.50" → "5.5" */
export function cleanNumber(raw: string | number): string {
  return cleanNumberText(String(raw));
}

/** "5%" | "$2,000" | "EUR 2,000.50": money in `currency`, cents only when present. */
export function amountText(a: Amount, currency: string): string {
  return a.unit === 'percent' ? `${cleanNumber(a.value)}%` : moneyText(a.value, currency, 'cents_when_present');
}

/** "$100K" | "EUR 1.5M": an account size in `currency`. */
export function sizeLabel(accountSize: string, currency: string): string {
  return moneyText(accountSize, currency, 'compact');
}
